// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suivi-commande {}

.header-content {
  display: flex;
  justify-content: space-between;
}

.suivi-commande-title {
  position: relative;
  background-color: black;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 2rem 4rem;
  color: #FFFDFC;
  margin-bottom: 2rem;
}

.suivi-commande-title h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.suivi-de-commande-content {
  padding: 0 3.5rem 2rem 3.5rem;
}

.subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 2rem;
}

.subsequent-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1.8rem 2.5rem;
  background: #D7D9D9;
  border-radius: 50px;
  font-weight: 700;
  font-size: 3.2rem;
  margin-bottom: 2rem;
}

.commande-status .status-header {
  margin-bottom: 0;
}

.status-header span {
  font-size: 1.6rem;
  font-weight: 700;
}

.status-accepté {
  color: #00A708;
}

.status-brouillon {
  color: #6B7280;
}

.status-action-requise {
  color: #F4751B;
}

.status-refusé {
  color: #D90E0E;
}

.status-en-attente {
  color: #6B7280;
}

.status-candidature-en-cours {
  color: #6B7280;
}

.dates {
  font-size: 1.8rem;
  font-weight: 700;
}

.dates span {
  color: #6B7280;
  font-weight: 400;
}

.dates p {
  margin-bottom: 0.5rem;
}

.commande-status {
  margin-top: 2rem;
  background: #FFFDFC;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 2rem;
  font-weight: 600;
  width: 100%;
}

.commande-status .status-content {
  display: flex;
  justify-content: space-between;
}

.commande-status button {
  width: 260px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem
}

.commande-status button svg {
  fill: #FFFDFC
}

.content-wrapper {
  gap: 2rem;
}

/* .suivi-commande-section > h3 {
  background-color: #595959;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem;
  color: #FFFDFC;
} */

.second-row {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.second-row .details-client {
  width: 100%;
}

.second-row .documents-list {
  width: 50%;
}

.third-row {
  margin-top: 3rem;
}

.suivi-details {
  background: #FFFDFC;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 2rem;
}

.suivi-details h2 {
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

/* .section-consultation {
  background: #FFFDFC;
  border: 1px solid #E5E7EB;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 2rem;
  margin-bottom: 2rem;
} */

.section-consultation h3 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.definition-besoin {
  min-height: 100px;
  white-space: pre-wrap;
}

/* Styles pour les tableaux en mode lecture seule */
/* .articles-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
} */

/* Style pour le mode affichage */
.info-text.definition-besoin {
  min-height: 200px;
  /* Plus grand également en mode affichage */
  max-height: 400px;
  /* Limiter la hauteur maximale */
  overflow-y: auto;
  /* Ajouter un défilement si nécessaire */
  white-space: pre-wrap;
  /* Respecter les sauts de ligne */
  padding: 1.5rem;
  background-color: #F3F4F6;
  border-radius: 0.8rem;
  line-height: 1.5;
}

/* Styles pour l'onglet Marché */
.tab-marche .signature-complete {
  padding: 2rem;
  background-color: rgba(16, 185, 129, 0.1);
  border-radius: 0.8rem;
  margin-bottom: 2rem;
}

.tab-marche .signature-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
  text-align: center;
}

.tab-marche .signature-success svg {
  margin-bottom: 1rem;
}

.tab-marche .signature-success h4 {
  font-size: 1.8rem;
  color: #10B981;
  margin-bottom: 0.5rem;
}

.tab-marche .signature-success p {
  color: #4B5563;
  font-size: 1.4rem;
}

.tab-marche .document-actions {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
}

.tab-marche .signature-pending {
  padding: 2rem;
  background-color: #F9FAFB;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
}

.tab-marche .signature-pending h4 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #2C3948;
}

.tab-marche .signature-pending p {
  margin-bottom: 1.5rem;
  color: #4B5563;
}

.tab-marche .yousign-iframe-container {
  width: 100%;
  margin: 2rem 0;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  overflow: hidden;
}

.tab-marche .yousign-iframe {
  width: 100%;
  height: 600px;
  border: none;
}

.tab-marche .signature-instructions {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #FEF3C7;
  border-left: 4px solid #F59E0B;
  border-radius: 0.4rem;
}

.tab-marche .signature-instructions p {
  margin-bottom: 0.5rem;
  font-size: 1.4rem;
  color: #92400E;
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  font-size: 1.6rem;
  color: #6B7280;
}

.error-message p:last-child {
  color: #6B7280;
  font-size: 1.4rem;
  margin-top: 0.5rem;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.6rem;
  color: #6B7280;
  background-color: #F9FAFB;
  border-radius: 0.8rem;
  padding: 2rem;
  margin: 2rem 0;
}

/* Assurer que l'entrée prend toute la largeur disponible */


/* Style spécifique pour la bordure quand l'input a le focus */
.prix-input-container:focus-within {
  border-color: #0486FF;
  box-shadow: 0 0 0 2px rgba(4, 134, 255, 0.2);
}

/* Styles pour la section de coordonnées à deux colonnes */
.coordinates-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.coordinates-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.coordinates-column {
  flex: 1 1;
  min-width: 280px;
  border-radius: 8px;
  padding: 1.5rem;
}

.coordinates-column h4 {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  color: #2C3948;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.details-block p {
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
}

.empty-details {
  color: #6B7280;
  font-style: italic;
}

.documents-section h4 {
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
  color: #2C3948;
}

.section-separator {
  margin-top: 20px;
  font-weight: bold;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.note-globale {
  font-weight: bold;
  margin-top: 2rem;
  font-size: 1.1em;
  color: #2C3948;
  text-align: center;
  padding: 1.5rem;
  background-color: rgba(218, 112, 39, 0.15);
  border-radius: 0.8rem;
}

.note-globale-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.note-globale h4 {
  font-size: 1.6rem;
  margin-bottom: 1rem;
  color: #2C3948;
}

.note-globale .note-value {
  font-size: 2.4rem;
  font-weight: 700;
  color: #2C3948;
  margin-bottom: 0.8rem;
}

.note-globale .note-explication {
  font-size: 1.4rem;
  color: #6B7280;
}

.note-globale .meilleure-offre {
  color: #10B981;
  font-weight: 600;
}

.note-globale .pire-offre {
  color: #EF4444;
  font-weight: 600;
}

.note-globale .offre-moyenne {
  color: #F59E0B;
  font-weight: 600;
}

.step-container .action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  margin-top: 2rem;
}

.presta-comparaison-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}

.presta-col {
  background-color: rgba(215, 217, 217, 0.20);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.presta-header {
  margin-bottom: 2rem;
  background-color: rgba(194, 194, 194, 0.50);
  ;
  border-radius: 10px;
  padding: 1rem;
  color: #2C3948;
}

/* Styles pour le footer des prestataires */
.presta-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #eaeaea;
  min-height: 50px;
  /* Hauteur minimale pour s'assurer qu'il y a assez d'espace */
}

.presta-footer-left {
  align-self: flex-end;
  /* Force l'alignement en bas */
}

.presta-footer-right {
  width: fit-content;
  margin: 2rem auto 0 auto;
}

.presta-col {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.articles-table th[colspan="2"] {
  background-color: rgba(194, 194, 194, 0.50);
  color: #2C3948;
  text-align: center;
  padding: 0.8rem;
  font-weight: 600;
}

.total-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
  margin-bottom: 3rem;
}

.total-section p {
  font-size: 1.6rem;
  font-weight: 900;
  margin-bottom: 2rem;
}

.form-row.date {
  grid-template-columns: 1fr 1fr 1fr !important;
}

.form-row.nom-et-ref {
  grid-template-columns: 70% 28% !important;
}

.form-row.adresse {
  grid-template-columns: 60% 18.1% 18.1% !important;
}

.client {
  font-size: 1.6rem;
  color: #6B7280;
}`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommande/SuiviDeCommande.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kHAAuJ;EACvJ,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;GAOG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;;;;GAIG;;AAEH,iCAAiC;AACjC;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,wCAAwC;EACxC,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA,2DAA2D;;;AAG3D,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;;EAE3C,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".suivi-commande {}\r\n\r\n.header-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.suivi-commande-title {\r\n  position: relative;\r\n  background-color: black;\r\n  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg');\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  padding: 2rem 4rem;\r\n  color: #FFFDFC;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.suivi-commande-title h1 {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 100%;\r\n  display: block;\r\n}\r\n\r\n.suivi-de-commande-content {\r\n  padding: 0 3.5rem 2rem 3.5rem;\r\n}\r\n\r\n.subtitle {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  font-size: 1.6rem;\r\n  font-weight: 500;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.subsequent-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.8rem 2.5rem;\r\n  background: #D7D9D9;\r\n  border-radius: 50px;\r\n  font-weight: 700;\r\n  font-size: 3.2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.commande-status .status-header {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.status-header span {\r\n  font-size: 1.6rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.status-accepté {\r\n  color: #00A708;\r\n}\r\n\r\n.status-brouillon {\r\n  color: #6B7280;\r\n}\r\n\r\n.status-action-requise {\r\n  color: #F4751B;\r\n}\r\n\r\n.status-refusé {\r\n  color: #D90E0E;\r\n}\r\n\r\n.status-en-attente {\r\n  color: #6B7280;\r\n}\r\n\r\n.status-candidature-en-cours {\r\n  color: #6B7280;\r\n}\r\n\r\n.dates {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.dates span {\r\n  color: #6B7280;\r\n  font-weight: 400;\r\n}\r\n\r\n.dates p {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.commande-status {\r\n  margin-top: 2rem;\r\n  background: #FFFDFC;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n  font-weight: 600;\r\n  width: 100%;\r\n}\r\n\r\n.commande-status .status-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.commande-status button {\r\n  width: 260px;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1.5rem\r\n}\r\n\r\n.commande-status button svg {\r\n  fill: #FFFDFC\r\n}\r\n\r\n.content-wrapper {\r\n  gap: 2rem;\r\n}\r\n\r\n/* .suivi-commande-section > h3 {\r\n  background-color: #595959;\r\n  border-top-right-radius: 10px;\r\n  border-top-left-radius: 10px;\r\n  padding: 1rem;\r\n  color: #FFFDFC;\r\n} */\r\n\r\n.second-row {\r\n  display: flex;\r\n  gap: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.second-row .details-client {\r\n  width: 100%;\r\n}\r\n\r\n.second-row .documents-list {\r\n  width: 50%;\r\n}\r\n\r\n.third-row {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.suivi-details {\r\n  background: #FFFDFC;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n}\r\n\r\n.suivi-details h2 {\r\n  font-size: 2.4rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n/* .section-consultation {\r\n  background: #FFFDFC;\r\n  border: 1px solid #E5E7EB;\r\n  border-bottom-left-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n} */\r\n\r\n.section-consultation h3 {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.definition-besoin {\r\n  min-height: 100px;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n/* Styles pour les tableaux en mode lecture seule */\r\n/* .articles-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 1rem;\r\n} */\r\n\r\n/* Style pour le mode affichage */\r\n.info-text.definition-besoin {\r\n  min-height: 200px;\r\n  /* Plus grand également en mode affichage */\r\n  max-height: 400px;\r\n  /* Limiter la hauteur maximale */\r\n  overflow-y: auto;\r\n  /* Ajouter un défilement si nécessaire */\r\n  white-space: pre-wrap;\r\n  /* Respecter les sauts de ligne */\r\n  padding: 1.5rem;\r\n  background-color: #F3F4F6;\r\n  border-radius: 0.8rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Styles pour l'onglet Marché */\r\n.tab-marche .signature-complete {\r\n  padding: 2rem;\r\n  background-color: rgba(16, 185, 129, 0.1);\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.tab-marche .signature-success {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n}\r\n\r\n.tab-marche .signature-success svg {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.tab-marche .signature-success h4 {\r\n  font-size: 1.8rem;\r\n  color: #10B981;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.tab-marche .signature-success p {\r\n  color: #4B5563;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.tab-marche .document-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.tab-marche .signature-pending {\r\n  padding: 2rem;\r\n  background-color: #F9FAFB;\r\n  border-radius: 0.8rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.tab-marche .signature-pending h4 {\r\n  font-size: 1.8rem;\r\n  margin-bottom: 1rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.tab-marche .signature-pending p {\r\n  margin-bottom: 1.5rem;\r\n  color: #4B5563;\r\n}\r\n\r\n.tab-marche .yousign-iframe-container {\r\n  width: 100%;\r\n  margin: 2rem 0;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 0.5rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.tab-marche .yousign-iframe {\r\n  width: 100%;\r\n  height: 600px;\r\n  border: none;\r\n}\r\n\r\n.tab-marche .signature-instructions {\r\n  margin-top: 1.5rem;\r\n  padding: 1rem;\r\n  background-color: #FEF3C7;\r\n  border-left: 4px solid #F59E0B;\r\n  border-radius: 0.4rem;\r\n}\r\n\r\n.tab-marche .signature-instructions p {\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.4rem;\r\n  color: #92400E;\r\n}\r\n\r\n.loading-indicator {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 300px;\r\n  font-size: 1.6rem;\r\n  color: #6B7280;\r\n}\r\n\r\n.error-message p:last-child {\r\n  color: #6B7280;\r\n  font-size: 1.4rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.empty-state {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 200px;\r\n  font-size: 1.6rem;\r\n  color: #6B7280;\r\n  background-color: #F9FAFB;\r\n  border-radius: 0.8rem;\r\n  padding: 2rem;\r\n  margin: 2rem 0;\r\n}\r\n\r\n/* Assurer que l'entrée prend toute la largeur disponible */\r\n\r\n\r\n/* Style spécifique pour la bordure quand l'input a le focus */\r\n.prix-input-container:focus-within {\r\n  border-color: #0486FF;\r\n  box-shadow: 0 0 0 2px rgba(4, 134, 255, 0.2);\r\n}\r\n\r\n/* Styles pour la section de coordonnées à deux colonnes */\r\n.coordinates-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n.coordinates-columns {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 2rem;\r\n}\r\n\r\n.coordinates-column {\r\n  flex: 1;\r\n  min-width: 280px;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.coordinates-column h4 {\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.8rem;\r\n  color: #2C3948;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.details-block p {\r\n  margin-bottom: 0.8rem;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.empty-details {\r\n  color: #6B7280;\r\n  font-style: italic;\r\n}\r\n\r\n.documents-section h4 {\r\n  margin-bottom: 1.5rem;\r\n  font-size: 1.8rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.section-separator {\r\n  margin-top: 20px;\r\n  font-weight: bold;\r\n  border-top: 1px solid #e5e7eb;\r\n  padding-top: 12px;\r\n}\r\n\r\n.note-globale {\r\n  font-weight: bold;\r\n  margin-top: 2rem;\r\n  font-size: 1.1em;\r\n  color: #2C3948;\r\n  text-align: center;\r\n  padding: 1.5rem;\r\n  background-color: rgba(218, 112, 39, 0.15);\r\n  border-radius: 0.8rem;\r\n}\r\n\r\n.note-globale-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.note-globale h4 {\r\n  font-size: 1.6rem;\r\n  margin-bottom: 1rem;\r\n  color: #2C3948;\r\n}\r\n\r\n.note-globale .note-value {\r\n  font-size: 2.4rem;\r\n  font-weight: 700;\r\n  color: #2C3948;\r\n  margin-bottom: 0.8rem;\r\n}\r\n\r\n.note-globale .note-explication {\r\n  font-size: 1.4rem;\r\n  color: #6B7280;\r\n}\r\n\r\n.note-globale .meilleure-offre {\r\n  color: #10B981;\r\n  font-weight: 600;\r\n}\r\n\r\n.note-globale .pire-offre {\r\n  color: #EF4444;\r\n  font-weight: 600;\r\n}\r\n\r\n.note-globale .offre-moyenne {\r\n  color: #F59E0B;\r\n  font-weight: 600;\r\n}\r\n\r\n.step-container .action-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1.5rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.presta-comparaison-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.presta-col {\r\n  background-color: rgba(215, 217, 217, 0.20);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.presta-header {\r\n  margin-bottom: 2rem;\r\n  background-color: rgba(194, 194, 194, 0.50);\r\n  ;\r\n  border-radius: 10px;\r\n  padding: 1rem;\r\n  color: #2C3948;\r\n}\r\n\r\n/* Styles pour le footer des prestataires */\r\n.presta-footer {\r\n  margin-top: 20px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid #eaeaea;\r\n  min-height: 50px;\r\n  /* Hauteur minimale pour s'assurer qu'il y a assez d'espace */\r\n}\r\n\r\n.presta-footer-left {\r\n  align-self: flex-end;\r\n  /* Force l'alignement en bas */\r\n}\r\n\r\n.presta-footer-right {\r\n  width: fit-content;\r\n  margin: 2rem auto 0 auto;\r\n}\r\n\r\n.presta-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.articles-table th[colspan=\"2\"] {\r\n  background-color: rgba(194, 194, 194, 0.50);\r\n  color: #2C3948;\r\n  text-align: center;\r\n  padding: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.total-section {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 2rem;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.total-section p {\r\n  font-size: 1.6rem;\r\n  font-weight: 900;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.form-row.date {\r\n  grid-template-columns: 1fr 1fr 1fr !important;\r\n}\r\n\r\n.form-row.nom-et-ref {\r\n  grid-template-columns: 70% 28% !important;\r\n}\r\n\r\n.form-row.adresse {\r\n  grid-template-columns: 60% 18.1% 18.1% !important;\r\n}\r\n\r\n.client {\r\n  font-size: 1.6rem;\r\n  color: #6B7280;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
